// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App{
  margin: 0;
}
.top-div{
  position: relative;
  margin: 0;
}
.desktop-container{
  display: none;
}
.mobile-container{
  display: block;
  position: relative;
}
.close-btn{
  background-color: white;
}
.wine-title-div{
  display: block;
  padding: 9% 0 7% 7%;
}
.wine-title{
  margin-right: 2%;
  font-size: 7.5vw;
  line-height: 9vw;;
  font-weight: 700;
  font-style: normal;
  letter-spacing: .05vw;
  color: rgb(0, 0, 0);
  margin: 0 0 .75% 0;
}
.year{
  letter-spacing: .05vw;
  font-size: 5.75vw;
  line-height: 7vw;
  color: rgb(0, 0, 0);
  letter-spacing: .05vw;
  margin: 0;
  font-weight: 400;
}
.content-div{
  display: flex;
  position: relative; 
  z-index: 2;
  width: 100vw;
}
.big-wine-container{
  position: absolute;
  z-index: 3;
  height: 140vw;
  width: 21vw;
  padding: 0 5vw 0 6vw;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding-top: 5%;;
}
.wine-image{
  height: 75%;
  z-index: 3;
  background-color: transparent;
  margin-bottom: 15%;
  margin-left: 2%;
}
.wine-logo{
  width: 100%;
  height: auto;
  margin: 0;
  margin-left: 0%;
}
.right-col{
  width: 100%;
  height: auto;
}
.top-right{
  display: flex;
  flex-direction: column;
  justify-content: start;
  position: relative;
  padding-right: 5%;
  padding-left: 36.5%;
  padding-bottom: 11%;
}
.bottom-right{
  height: auto;
  padding-top: 3%;
  padding-right: 5%;
  padding-left: 36.5%;
  padding-bottom: 5%;
}
.my-profile-header{
  margin: 0;
  font-size: 4.5vw;
  line-height: 5.5vw;
  padding-top: 7%;
  padding-bottom: 3%;
  color: black;
  font-weight: 700;
  font-style: normal;
  letter-spacing: .05vw;
}
.user-profile{
  margin: 0;
  font-size: 3.65vw;
  line-height: 5.15vw;
  color: rgb(0, 0, 0);
  font-weight: 400;
  font-style: normal;
  letter-spacing: .05vw;
}
.flavors-header{
  margin: 0;
  padding-top: 12%;
  padding-bottom: 5.75%;
  font-size: 4vw;
  color: black;
  font-weight: 700;
  font-style: normal;
  letter-spacing: .05vw;
}
.flavors-container{
  height: auto;
  display: flex;
}
.flavor-box{
  height: 100%;
  margin-right: 10%;
  width: 24%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: end; 
}
.flav-img-container{
  display: flex;
  align-items: center;
  justify-content: center;
  height: 13vw;
  width: 13vw;
  border-radius: 10vw;
  margin-bottom: 14%;
}
.user-flavor-img{
  width: 85%;
}
.flavor-title{
  font-size: 3vw;
  line-height: 4vw;
  font-weight: 400;
  font-style: normal;
  letter-spacing: .05vw;
  text-align: center;
  margin: 0;
}
.bottom{
  margin-top: 6%;
}
.acid-sweetness-columns{
  display: flex;
  margin-top: 12%;
}
.acidity-col{
  display: block;
  width: 45%;
  margin-right: 10%;
}
.acidity-header{
  margin: 0;
  padding-bottom: 3%;
  font-size: 3.5vw;
  margin-bottom: 4%;
  color: black;
  font-weight: 600;
  font-style: normal;
  letter-spacing: .05vw;
}
.acidity-bar{
  display: flex;
  align-items: center;
  height: 2.75vw;
  width: 100%;
  border: 1px rgb(150, 150, 150) solid;
  border-radius: 10vw;
}
.sweetness-col{
  display: block;
  width: 45%;
}
.sweetness-bar{
  display: flex;
  align-items: center;
  height: 2.75vw;
  width: 100%;
  border: 1px rgb(150, 150, 150) solid;
  border-radius: 10vw;
}
.acid-label-columns{
  display: flex; 
  width: 100%;
}
.l-acid-col{
  width: 50%;
}
.r-acid-col{
  width: 50%;
  display: flex;
  justify-content: end;
}
.low-lable{
  font-size: 2.35vw;
  margin-bottom: 3%;
  color: black;
  font-weight: 400;
  margin: 0;
  padding-top: 13%;
  margin-left: 2%;
  letter-spacing: .01vw;
}
.high-lable{
  font-size: 2.35vw;
  color: black;
  font-weight: 400;
  margin: 0;
  padding-top: 13%;
  padding-right: 0%;
  letter-spacing: .01vw;
}
.qr-code-section{
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10% 0 6.5% 0%;
  width: 100%;
}
.share-link{
  margin-bottom: 5%;
  min-height: 27vw;
  margin-right: 3%;
  margin-left: 3%;
  width: 22%;
  text-decoration: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  background-color: transparent;
  border: none;
}
.share-img{
  width: 75%;
  margin-bottom: 13%;
}
.share-lable{
  text-decoration: none;
  color: black;
  font-size: 3.25vw;
  line-height: 4.25vw;
  font-weight: 400;
  margin: 0;
}
.fade-in {
  opacity: 1;
  transition: opacity .5s linear;
}
.invisible {
  opacity: .9;
}
/* Optional: You may want to add this to your loading-screen class */
.loading-screen {
  opacity: 1;
  transition: opacity 0.5s ease-out;
}
.loading-screen {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100%;
  background-color: #fdf9f1;
}
.loading-screen {
  margin-top: 0px;
  color: #860000;
}
.load-message{
  color: black;
  font-family: "Helvetica-reg";
  font-weight: 600;
  letter-spacing: .25vw;
  font-size: 5.75vw;
}
.loading-spinner {
  width: 20vw;
  height: auto;
  border-radius: 0%;
  animation: spin 4s linear infinite;
  margin-bottom: 20%;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.sparkling-qr-mobile{
  background-color: #fdf9f1;
}



@media only screen and (min-width: 700px) and (min-height: 1000px){

  .App{
    margin: 0;
  }
  .top-div{
    position: relative;
    margin: 0;
  }
  .desktop-container{
    display: none;
  }
  .mobile-container{
    display: block;
    position: relative;
  }
  .wine-title-div{
    display: block;
    padding: 7% 0 1% 5%;
  }
  .wine-title{
    margin-right: 2%;
    font-size: 4vw;
    font-weight: 700;
    font-style: normal;
    letter-spacing: .015vw;
    color: rgb(0, 0, 0);
    margin: 0;
    line-height: 4.5vw;
  }
  .year{
    font-weight: 400;
    font-style: normal;
    letter-spacing: .015vw;
    font-size: 3.25vw;
    line-height: 5vw;
    color: rgb(0, 0, 0);
    margin: 0;
  }
  .content-div{
    display: flex;
    position: relative; 
    z-index: 2;
    width: 100vw;
  }
  .big-wine-container{
    position: absolute;
    z-index: 3;
    height: 115vw;
    width: 20vw;
    padding: 0 5vw 0 5vw;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding-top: 0%;;
  }
  .wine-image{
    height: 75%;
    z-index: 3;
    background-color: transparent;
    margin-bottom: 12%;
    margin-left: 2%;
  }
  .wine-logo{
    width: 100%;
    height: auto;
    margin: 0;
  }
  .right-col{
    width: 100%;
    height: auto;
  }
  .top-right{
    display: flex;
    flex-direction: column;
    justify-content: start;
    position: relative;
    padding-right: 5%;
    padding-left: 35%;
    padding-bottom: 8%;
  }
  .bottom-right{
    height: auto;
    padding-top: 2%;
    padding-right: 5%;
    padding-left: 35%;
    padding-bottom: 5%;
  }
  .my-profile-header{
    margin: 0;
    line-height: 2.5vw;
    font-size: 2.5vw;
    padding-top: 7%;
    padding-bottom: 2%;
    color: black;
    font-weight: 700;
    font-style: normal;
    letter-spacing: .015vw;
  }
  .user-profile{
    margin: 0;
    font-size: 2vw;
    line-height: 3vw;
    color: black;
    font-weight: 400;
    font-style: normal;
    letter-spacing: .02vw;
  }
  .flavors-header{
    margin: 0;
    padding-top: 8%;
    padding-bottom: 3.5%;
    font-size: 2.5vw;
    color: black;
    font-weight: 600;
    font-style: normal;
    letter-spacing: .015vw;
  }
  .flavors-container{
    height: auto;
    display: flex;
  }
  .flavor-box{
    height: 100%;
    margin-right: 6%;
    width: 20%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: end; 
  }
  .flav-img-container{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 7vw;
    width: 7vw;
    border-radius: 10vw;
    margin-bottom: 10%;
  }
  .user-flavor-img{
    width: 70%;
  }
  .flavor-title{
    font-size: 1.75vw;
    line-height: 2.5vw;
    font-weight: 400;
    font-style: normal;
    letter-spacing: .015vw;
    text-align: center;
    margin: 0;
  }
  .bottom{
    margin-top: 6%;
  }
  .acid-sweetness-columns{
    display: flex;
    margin-top: 10%;
  }
  .acidity-col{
    display: block;
    width: 45%;
    margin-right: 10%;
  }
  .acidity-header{
    margin: 0;
    padding-bottom: 3%;
    font-size: 2.15vw;
    margin-bottom: 3%;
    color: black;
    font-weight: 600;
    font-style: normal;
    letter-spacing: .015vw;
  }
  .acidity-bar{
    display: flex;
    align-items: center;
    height: 1.8vw;
    width: 100%;
    border: 1px rgb(150, 150, 150) solid;
    border-radius: 5vw;
  }
  .sweetness-col{
    display: block;
    width: 45%;
  }
  .sweetness-bar{
    display: flex;
    align-items: center;
    height: 1.8vw;
    width: 100%;
    border: 1px rgb(150, 150, 150) solid;
    border-radius: 5vw;
  }
  .acid-label-columns{
    display: flex; 
    width: 100%;
  }
  .l-acid-col{
    width: 50%;
  }
  .r-acid-col{
    width: 50%;
    display: flex;
    justify-content: end;
  }
  .low-lable{
    font-size: 1.5vw;
    margin-bottom: 3%;
    color: black;
    font-weight: 400;
    margin: 0;
    padding-top: 12%;
    margin-left: 2%;
  }
  .high-lable{
    font-size: 1.5vw;
    color: black;
    font-weight: 400;
    margin: 0;
    padding-top: 12%;
    padding-right: 2%;
  }
  .qr-code-section{
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5% 0 4% 0%;
    width: 100%;
  }
  .share-link{
    margin-bottom: 5%;
    min-height: 20vw;
    margin-right: 4%;
    margin-left: 4%;
    width: 20%;
    text-decoration: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    background-color: transparent;
    border: none;
  }
  .share-img{
    width: 49%;
    margin-bottom: 11%;
  }
  .share-lable{
    text-decoration: none;
    color: black;
    font-size: 2.25vw;
    line-height: 3.5vw;
    font-weight: 400;
    margin: 0;
  }
  .loading-screen {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100%;
    background-color: #fdf9f1;
  }
  .loading-screen {
    margin-top: 0px;
    color: #860000;
  }
  .load-message{
    color: black;
    font-family: "helvetica-neue-lt-pro", sans-serif;
    font-weight: 500;
    letter-spacing: .5px;
    font-size: 32px;
  }
  .loading-spinner {
    width: 95px;
    height: 95px;
    border-radius: 0%;
    animation: spin 4s linear infinite;
    margin-bottom: 10px;
  }
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  .fade-in {
    opacity: 1;
    transition: opacity .8s ease-in;
  }
  
  .invisible {
    opacity: .1;
  }
  .loading-screen {
    opacity: 1;
    transition: opacity 0.5s ease-out;
  }
}


@media screen and (min-width: 1000px){
  .mobile-container{
    display: none;
  }
  .desktop-container{
    display: block;
    position: relative;
  }
  .large-wine-container{
    display: flex;
    position: absolute;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 25%;
    top: 0;
    left: 0; 
    background-color: transparent !important;
    z-index: 3;
    height: 92vh;
  }
  .large-sparkling-container{
    background-color: transparent !important;
    top: 20px
  }
  .header{
    display: flex;
    position: relative;
    height: 11vh;
    padding-left: 25%;
    padding-right: 5%;
    border-bottom: 3px white solid;
  }
  .content{
    background-color: #fdf9f1;
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;
    min-height: 75.5vh;
    padding-left: 25%;
    padding-right: 4%;
  }
  .sparkling-content{
    min-height: 78vh;
  }
  .wine-img{
    height: 82%;
  }
  .qr-code-section{
    background-color: transparent;
    display: flex;
    align-items: center;
    justify-content: start;
    padding: 0% 0 0% 0%;
    width: 100%;
  }
  .share-link{
    margin-bottom: 0%;
    min-height: 100%;
    margin-right: 14px;
    margin-left: 0px;
    width: 130px;
    text-decoration: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
    background-color: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
  }
  .share-img{
    width: 32%;
    margin-bottom: 0%;
    margin-right: 8px;
  }
  .share-lable{
    text-decoration: none;
    color: black;
    font-size: 13px;
    line-height: 15px;
    font-weight: 400;
    letter-spacing: .25px;
    margin: 0;
    text-align: left;
  }
  .logo-desk-container{
    height: 100%;
    display: flex;
    align-items: center;
  }
  .wine-logo{
    width: auto;
    height: 68%;
    margin: 0;
    padding: 0;
  }
  .name-div{
    display: flex;
    justify-content: end;
    align-items: end;
    margin-bottom: 35px;
  }
  .wine-title{
    font-size: 32px;
    font-weight: 700;
    font-style: normal;
    letter-spacing: 1px;
    color: rgb(26, 26, 26);
    margin: 0 22px 0 0;
    line-height: 25px;
    letter-spacing: .25px;
  }
  .wine-year{
    font-size: 24px;
    font-weight: 400;
    color: rgb(26, 26, 26);
    letter-spacing: .25px;
  }
  .flavor-columns{
    display: flex;
    width: 100%;
  }
  .l-col{
    width: 46%;
    margin-right: 4%;
  }
  .r-col{
    width: 46%;
    margin-left: 4%;
  }
  .profile-container{
    min-height: 135px;
  }
  .my-profile-header{
    margin: 0;
    line-height: 18px;
    font-size: 18px;
    padding-top: 0;
    padding-bottom: 10px;
    color: black;
    font-weight: 700;
    font-style: normal;
    letter-spacing: .25px;
  }
  .user-profile{
    margin: 0;
    font-size: 14px;
    line-height: 20px;
    color: black;
    font-weight: 400;
    font-style: normal;
    letter-spacing: .25px;
  }
  .flavors-header{
    margin: 0;
    padding-top: 15px;
    padding-bottom: 12px;
    font-size: 16px;
    color: black;
    font-weight: 700;
    font-style: normal;
    letter-spacing: .25px;
  }
  .flavors-container{
    min-height: 98px;
  }
  .flavor-box{
    height: 100%;
    margin-right: 22px;
    width: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: end; 
  }
  .flav-img-container{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 45px;
    width: 45px;
    border-radius: 30px;
    margin-bottom: 10px;
  }
  .user-flavor-img{
    width: 70%;
  }
  .flavor-title{
    font-size: 11px;
    line-height: 14px;
    font-weight: 400;
    font-style: normal;
    letter-spacing: .25px;
    text-align: center;
    margin: 0;
  }
  .acid-sweetness-columns{
    display: flex;
    margin-top: 10px;
  }
  .acidity-col{
    display: block;
    width: 45%;
    margin-right: 10%;
  }
  .acidity-header{
    margin: 0;
    padding-bottom: 7px;
    font-size: 13px;
    margin-bottom: 2px;
    color: black;
    font-weight: 700;
    font-style: normal;
    letter-spacing: .25px;
  }
  .acidity-bar{
    display: flex;
    align-items: center;
    height: 12px;
    width: 100%;
    border: 1px rgb(150, 150, 150) solid;
    border-radius: 5vw;
  }
  .sweetness-col{
    display: block;
    width: 45%;
  }
  .sweetness-bar{
    display: flex;
    align-items: center;
    height: 12px;
    width: 100%;
    border: 1px rgb(150, 150, 150) solid;
    border-radius: 30px;
  }
  .acid-label-columns{
    display: flex; 
    width: 100%;
  }
  .l-acid-col{
    width: 50%;
  }
  .r-acid-col{
    width: 50%;
    display: flex;
    justify-content: end;
  }
  .low-lable{
    font-size: 11px;
    margin-bottom: 3%;
    color: black;
    font-weight: 400;
    margin: 0;
    padding-top: 7px;
    margin-left: 2%
  }
  .high-lable{
    font-size: 11px;
    color: black;
    font-weight: 400;
    margin: 0;
    padding-top: 10px;
    padding-right: 2%;
  }

  .loading-screen {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100%;
    background-color: #fdf9f1;
  }
  .loading-screen {
    margin-top: 0px;
    color: #860000;
  }
  .load-message{
    color: black;
    font-family: "helvetica-neue-lt-pro", sans-serif;
    font-weight: 500;
    letter-spacing: .25px;
    font-size: 24px;
  }
  .loading-spinner {
    width: 70px;
    height: auto;
    border-radius: 0%;
    animation: spin 3s linear infinite;
    margin-bottom: 5px;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  .fade-in {
    opacity: 1;
    transition: opacity .7s ease-in;
  }
  
  .invisible {
    opacity: .8;
  }
  .loading-screen {
    opacity: 1;
    transition: opacity .2s ease-in;
  }
  .effervescence-column{
    margin-top: 20px;
  }
}

@media screen and (min-width: 1400px) {
  
  .mobile-container{
    display: none;
  }
  .desktop-container{
    display: block;
    position: relative;
  }
  .large-wine-container{
    display: flex;
    position: absolute;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 28%;
    top: 0;
    left: 0; 
    background-color: transparent;
    z-index: 3;
    height: 89vh;
  }
  .large-sparkling-container{
    background-color: transparent !important;
    top: 20px
  }
  .header{
    display: flex;
    position: relative;
    height: 10.5vh;
    padding-left: 28%;
    padding-right: 4%;
    border-bottom: 3px white solid;
  }
  .content{
    background-color: #fdf9f1;
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;
    min-height: 77vh;
    padding-left: 28%;
    padding-right: 5%;
  }
  .sparkling-content{
    min-height: 81vh;
  }
  .wine-img{
    height: 90%;
  }
  .qr-code-section{
    background-color: transparent;
    display: flex;
    align-items: center;
    justify-content: start;
    padding: 0% 0 0% 0%;
    width: 100%;
  }
  .share-link{
    margin-bottom: 0%;
    min-height: 100%;
    margin-right: 20px;
    margin-left: 0px;
    width: 150px;
    text-decoration: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
    background-color: transparent;
    border: none;
    padding: 0;
  }
  .share-img{
    width: 28%;
    margin-bottom: 0%;
    margin-right: 10px;
  }
  .share-lable{
    text-decoration: none;
    color: black;
    font-size: 13px;
    font-weight: 400;
    margin: 0;
    text-align: left;
    line-height: 16px;
  }
  .logo-desk-container{
    height: 100%;
    display: flex;
    align-items: center;
  }
  .wine-logo{
    width: auto;
    height: 65%;
    margin: 0;
    padding: 0;
  }
  .name-div{
    display: flex;
    justify-content: end;
    align-items: end;
    margin-bottom: 36px;
  }
  .wine-title{
    font-size: 38px;
    font-weight: 700;
    font-style: normal;
    letter-spacing: .25px;
    color: rgb(26, 26, 26);
    margin: 0 22px 0 0;
    line-height: 40px;
  }
  .wine-year{
    font-size: 30px;
    font-weight: 400;
    color: rgb(26, 26, 26);
    letter-spacing: .25px;
  }
  .flavor-columns{
    display: flex;
    width: 100%;
  }
  .l-col{
    width: 45%;
    margin-right: 5%;
  }
  .r-col{
    width: 45%;
    margin-left: 5%;
  }
  .profile-container{
    min-height: 142px;
  }
  .my-profile-header{
    margin: 0;
    line-height: 24px;
    font-size: 20px;
    padding-top: 0;
    padding-bottom: 10px;
    color: black;
    font-weight: 700;
    font-style: normal;
    letter-spacing: .25px;
  }
  .user-profile{
    margin: 0;
    font-size: 15px;
    line-height: 22px;
    color: black;
    font-weight: 400;
    font-style: normal;
    letter-spacing: .25px;
  }
  .flavors-header{
    margin: 0;
    padding-top: 22px;
    padding-bottom: 14px;
    font-size: 16px;
    color: black;
    font-weight: 700;
    font-style: normal;
    letter-spacing:.25px;
  }
  .flavors-container{
    min-height: 100px;
  }
  .flavor-box{
    height: 100%;
    margin-right: 13px;
    width: 75px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: end; 
  }
  .flav-img-container{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 54px;
    width: 54px;
    border-radius: 30px;
    margin-bottom: 10px;
  }
  .user-flavor-img{
    width: 80%;
  }
  .flavor-title{
    font-size: 12px;
    line-height: 14px;
    font-weight: 400;
    font-style: normal;
    letter-spacing: .5px;
    text-align: center;
    margin: 0;
  }
  .acid-sweetness-columns{
    display: flex;
    margin-top: 16px;
    width: 96%;
  }
  .acidity-col{
    display: block;
    width: 45%;
    margin-right: 10%;
  }
  .acidity-header{
    margin: 0;
    padding-bottom: 5px;
    font-size: 15px;
    margin-bottom: 5px;
    color: black;
    font-weight: 700;
    font-style: normal;
    letter-spacing: .25px;
  }
  .acidity-bar{
    display: flex;
    align-items: center;
    height: 13px;
    width: 100%;
    border: 1px rgb(150, 150, 150) solid;
    border-radius: 5vw;
  }
  .sweetness-col{
    display: block;
    width: 45%;
  }
  .sweetness-bar{
    display: flex;
    align-items: center;
    height: 13px;
    width: 100%;
    border: 1px rgb(150, 150, 150) solid;
    border-radius: 30px;
  }
  .acid-label-columns{
    display: flex; 
    width: 100%;
  }
  .l-acid-col{
    width: 45%;
  }
  .r-acid-col{
    width: 45%;
    display: flex;
    justify-content: end;
  }
  .low-lable{
    font-size: 11px;
    margin-bottom: 3%;
    color: black;
    font-weight: 400;
    margin: 0;
    padding-top: 8px;
    margin-left: 2%;
  }
  .high-lable{
    font-size: 11px;
    color: black;
    font-weight: 400;
    margin: 0;
    padding-top: 8px;
    padding-right: 0px;
    margin-right: -17px;
  }
  .loading-screen {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100%;
    background-color: #fdf9f1;
  }
  .loading-screen {
    margin-top: 0px;
    color: #860000;
    font-family: your-font-family, sans-serif;
  }
  .load-message{
    color: black;
    font-family: "helvetica-neue-lt-pro", sans-serif;
    font-weight: 500;
    letter-spacing: .35px;
    font-size: 26px;
    margin: 0;
    line-height: 34px;
  }
  .loading-spinner {
    width: 85px;
    height: 85px;
    border-radius: 0%;
    animation: spin 4s linear infinite;
    margin-bottom: 18px;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  .fade-in {
    opacity: 1;
    transition: opacity .6s ease-in;
  }
  .invisible {
    opacity: .8;
  }
  /* Optional: You may want to add this to your loading-screen class */
  .loading-screen {
    opacity: 1;
    transition: opacity 0.2s ease-in;
  }
  .effervescence-column{
    margin-top: 25px;
  }
}

@media screen and (min-width: 1900px){

  .mobile-container{
    display: none;
  }
  .desktop-container{
    display: block;
    position: relative;
  }
  .large-wine-container{
    display: flex;
    position: absolute;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 31%;
    top: 0;
    left: 0; 
    background-color: transparent;
    z-index: 3;
    height: 87vh;
  }
  .large-sparkling-container{
    background-color: transparent !important;
    top: 0px
  }
  .header{
    display: flex;
    position: relative;
    height: 10.5vh;
    padding-left: 31%;
    padding-right: 4%;
  }
  .content{
    background-color: #fdf9f1;
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: center;
    min-height: 76.75vh;
    padding-left: 31%;
    padding-right: 6%;
  }
  .sparkling-content{
    min-height: 80vh;
  }
  .wine-img{
    height: 89%;
  }
  .qr-code-section{
    background-color: transparent;
    display: flex;
    align-items: center;
    justify-content: start;
    padding: 0% 0 0% 0%;
    width: 100%;
  }
  .share-link{
    margin-bottom: 0%;
    min-height: 100%;
    margin-right: 22px;
    margin-left: 0px;
    width: 205px;
    text-decoration: none;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: start;
    background-color: transparent;
    border: none;
    padding: 0;
  }
  .share-img{
    width: 24%;
    margin-bottom: 0%;
    margin-right: 13px;
  }
  .share-lable{
    text-decoration: none;
    color: black;
    font-size: 15px;
    line-height: 20px;
    font-weight: 400;
    margin: 0;
    text-align: left;
    letter-spacing: .5px;
  }
  .logo-desk-container{
    height: 100%;
    display: flex;
    align-items: center;
  }
  .wine-logo{
    width: auto;
    height: 65%;
    margin: 0;
    padding: 0;
  }
  .name-div{
    display: flex;
    justify-content: end;
    align-items: end;
    margin-bottom: 42px;
  }
  .wine-title{
    font-size: 46px;
    font-weight: 700;
    font-style: normal;
    letter-spacing: .25px;
    color: rgb(26, 26, 26);
    margin: 0 22px 0 0;
    line-height: 48px;
  }
  .wine-year{
    font-size: 34px;
    font-weight: 400;
    color: rgb(26, 26, 26);
    letter-spacing: .25px;
  }
  .flavor-columns{
    display: flex;
    width: 100%;
  }
  .l-col{
    width: 43%;
    margin-right: 6%;
  }
  .r-col{
    width: 43%;
    margin-left: 6%;
  }
  .profile-container{
    min-height: 157px;
  }
  .my-profile-header{
    margin: 0;
    font-size: 24px;
    line-height: 28px;
    padding-top: 0;
    padding-bottom: 13px;
    color: black;
    font-weight: 700;
    font-style: normal;
    letter-spacing: .25px;
  }
  .user-profile{
    margin: 0;
    font-size: 16px;
    line-height: 24px;
    color: black;
    font-weight: 400;
    font-style: normal;
    letter-spacing: .25px;
  }
  .flavors-header{
    margin: 0;
    padding-top: 26px;
    padding-bottom: 15px;
    font-size: 19px;
    color: black;
    font-weight: 700;
    font-style: normal;
    letter-spacing: .25px;
  }
  .flavors-container{
    min-height: 112px;
  }
  .flavor-box{
    height: 100%;
    margin-right: 17px;
    width: 88px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: end; 
  }
  .flav-img-container{
    display: flex;
    align-items: center;
    justify-content: center;
    height: 61px;
    width: 61px;
    border-radius: 30px;
    margin-bottom: 15px;
  }
  .user-flavor-img{
    width: 77%;
  }
  .flavor-title{
    font-size: 13px !important;
    line-height: 18px !important;
    font-weight: 400;
    font-style: normal;
    letter-spacing: .25px;
    text-align: center;
    margin: 0;
  }
  .acid-sweetness-columns{
    display: flex;
    margin-top: 36px;
    width: 96%;
  }
  .acidity-col{
    display: block;
    width: 45%;
    margin-right: 13%;
  }
  .acidity-header{
    margin: 0;
    padding-bottom: 5px;
    font-size: 16px;
    margin-bottom: 7px;
    color: black;
    font-weight: 700;
    font-style: normal;
    letter-spacing: .25px;
  }
  .acidity-bar{
    display: flex;
    align-items: center;
    height: 15px;
    width: 100%;
    border: 1px rgb(150, 150, 150) solid;
    border-radius: 5vw;
  }
  .sweetness-col{
    display: block;
    width: 45%;
  }
  .sweetness-bar{
    display: flex;
    align-items: center;
    height: 15px!important;
    width: 100%;
    border: 1px rgb(150, 150, 150) solid;
    border-radius: 30px;
  }
  .acid-label-columns{
    display: flex; 
    width: 100%;
  }
  .l-acid-col{
    width: 50%;
  }
  .r-acid-col{
    width: 50%;
    display: flex;
    justify-content: end;
  }
  .low-lable{
    font-size: 13px;
    margin-bottom: 3%;
    color: black;
    font-weight: 400;
    letter-spacing: .25px;
    margin: 0;
    padding-top: 8px;
    margin-left: 2%;
  }
  .high-lable{
    font-size: 13px;
    color: black;
    font-weight: 400;
    margin: 0;
    padding-top: 8px;
    padding-right: 2px;
    letter-spacing: .25px;
    margin-right: 0;
  }

  .loading-screen {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100%;
    background-color: #fdf9f1;
  }
  .loading-screen {
    margin-top: 0px;
    color: #860000;
  }
  .load-message{
    color: black;
    font-family: "helvetica-neue-lt-pro", sans-serif;
    font-weight: 500;
    letter-spacing: .5px;
    font-size: 33px;
  }
  .loading-spinner {
    width: 95px;
    height: auto;
    border-radius: 0%;
    animation: spin 3s linear infinite;
    margin-bottom: 8px;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  .fade-in {
    opacity: 1;
    transition: opacity .6s ease-in;
  }
  .invisible {
    opacity: 0.9;
  }
  /* Optional: You may want to add this to your loading-screen class */
  .loading-screen {
    opacity: 1;
    transition: opacity 0.5s ease-out;
  }
  .effervescence-column{
    margin-top: 40px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,aAAa;AACf;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,WAAW;EACX,UAAU;EACV,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,UAAU;AACZ;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,cAAc;EACd,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;EACV,aAAa;EACb,oBAAoB;AACtB;AACA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,UAAU;EACV,8BAA8B;AAChC;AACA;EACE,WAAW;AACb;AACA,oEAAoE;AACpE;EACE,UAAU;EACV,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,YAAY;EACZ,4BAA4B;EAC5B,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kCAAkC;EAClC,kBAAkB;AACpB;AACA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;AACA;EACE,yBAAyB;AAC3B;;;;AAIA;;EAEE;IACE,SAAS;EACX;EACA;IACE,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,mBAAmB;EACrB;EACA;IACE,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,SAAS;EACX;EACA;IACE,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,WAAW;IACX,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,eAAe;EACjB;EACA;IACE,WAAW;IACX,UAAU;IACV,6BAA6B;IAC7B,kBAAkB;IAClB,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,SAAS;EACX;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,SAAS;IACT,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,SAAS;IACT,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,YAAY;IACZ,aAAa;EACf;EACA;IACE,YAAY;IACZ,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,UAAU;IACV,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,UAAU;EACZ;EACA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;IACb,eAAe;EACjB;EACA;IACE,cAAc;IACd,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,SAAS;IACT,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;EACxB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,oCAAoC;IACpC,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,UAAU;EACZ;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,oCAAoC;IACpC,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,aAAa;IACb,oBAAoB;EACtB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,UAAU;IACV,qBAAqB;IACrB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,2BAA2B;IAC3B,6BAA6B;IAC7B,YAAY;EACd;EACA;IACE,UAAU;IACV,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;EACX;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,yBAAyB;EAC3B;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,YAAY;IACZ,gDAAgD;IAChD,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kCAAkC;IAClC,mBAAmB;EACrB;EACA;IACE,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;EACpC;EACA;IACE,UAAU;IACV,+BAA+B;EACjC;;EAEA;IACE,WAAW;EACb;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;;AAGA;EACE;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,MAAM;IACN,OAAO;IACP,wCAAwC;IACxC,UAAU;IACV,YAAY;EACd;EACA;IACE,wCAAwC;IACxC;EACF;EACA;IACE,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,8BAA8B;EAChC;EACA;IACE,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,6BAA6B;IAC7B,YAAY;IACZ,UAAU;IACV,eAAe;EACjB;EACA;IACE,UAAU;IACV,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,qBAAqB;IACrB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,SAAS;IACT,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,WAAW;IACX,SAAS;IACT,UAAU;EACZ;EACA;IACE,aAAa;IACb,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;EACvB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,qBAAqB;EACvB;EACA;IACE,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,SAAS;IACT,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,oBAAoB;IACpB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,SAAS;IACT,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,oCAAoC;IACpC,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,UAAU;EACZ;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,oCAAoC;IACpC,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,aAAa;IACb,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB;EACF;EACA;IACE,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,yBAAyB;EAC3B;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,YAAY;IACZ,gDAAgD;IAChD,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kCAAkC;IAClC,kBAAkB;EACpB;;EAEA;IACE,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;EACpC;;EAEA;IACE,UAAU;IACV,+BAA+B;EACjC;;EAEA;IACE,WAAW;EACb;EACA;IACE,UAAU;IACV,+BAA+B;EACjC;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;;EAEE;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,MAAM;IACN,OAAO;IACP,6BAA6B;IAC7B,UAAU;IACV,YAAY;EACd;EACA;IACE,wCAAwC;IACxC;EACF;EACA;IACE,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,iBAAiB;IACjB,8BAA8B;EAChC;EACA;IACE,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,6BAA6B;IAC7B,YAAY;IACZ,UAAU;EACZ;EACA;IACE,UAAU;IACV,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,WAAW;IACX,SAAS;IACT,UAAU;EACZ;EACA;IACE,aAAa;IACb,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,qBAAqB;EACvB;EACA;IACE,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,SAAS;IACT,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,oBAAoB;IACpB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,SAAS;IACT,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;EACtB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,aAAa;IACb,gBAAgB;IAChB,UAAU;EACZ;EACA;IACE,cAAc;IACd,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,oCAAoC;IACpC,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,UAAU;EACZ;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,oCAAoC;IACpC,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,aAAa;IACb,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,yBAAyB;EAC3B;EACA;IACE,eAAe;IACf,cAAc;IACd,yCAAyC;EAC3C;EACA;IACE,YAAY;IACZ,gDAAgD;IAChD,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;IACf,SAAS;IACT,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kCAAkC;IAClC,mBAAmB;EACrB;;EAEA;IACE,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;EACpC;EACA;IACE,UAAU;IACV,+BAA+B;EACjC;EACA;IACE,WAAW;EACb;EACA,oEAAoE;EACpE;IACE,UAAU;IACV,gCAAgC;EAClC;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;;EAEE;IACE,aAAa;EACf;EACA;IACE,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,MAAM;IACN,OAAO;IACP,6BAA6B;IAC7B,UAAU;IACV,YAAY;EACd;EACA;IACE,wCAAwC;IACxC;EACF;EACA;IACE,aAAa;IACb,kBAAkB;IAClB,cAAc;IACd,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,yBAAyB;IACzB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,6BAA6B;IAC7B,YAAY;IACZ,UAAU;EACZ;EACA;IACE,UAAU;IACV,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,YAAY;IACZ,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,oBAAoB;EACtB;EACA;IACE,YAAY;IACZ,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,WAAW;IACX,SAAS;IACT,UAAU;EACZ;EACA;IACE,aAAa;IACb,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,qBAAqB;EACvB;EACA;IACE,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;IACV,gBAAgB;EAClB;EACA;IACE,UAAU;IACV,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,oBAAoB;IACpB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,SAAS;IACT,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,SAAS;IACT,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,oBAAoB;EACtB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,0BAA0B;IAC1B,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;IAClB,SAAS;EACX;EACA;IACE,aAAa;IACb,gBAAgB;IAChB,UAAU;EACZ;EACA;IACE,cAAc;IACd,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,SAAS;IACT,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;EACvB;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,oCAAoC;IACpC,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,UAAU;EACZ;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,oCAAoC;IACpC,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,WAAW;EACb;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,aAAa;IACb,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;IACrB,SAAS;IACT,gBAAgB;IAChB,eAAe;EACjB;EACA;IACE,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,yBAAyB;EAC3B;EACA;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,YAAY;IACZ,gDAAgD;IAChD,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;EACjB;EACA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kCAAkC;IAClC,kBAAkB;EACpB;;EAEA;IACE,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;EACpC;EACA;IACE,UAAU;IACV,+BAA+B;EACjC;EACA;IACE,YAAY;EACd;EACA,oEAAoE;EACpE;IACE,UAAU;IACV,iCAAiC;EACnC;EACA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".App{\n  margin: 0;\n}\n.top-div{\n  position: relative;\n  margin: 0;\n}\n.desktop-container{\n  display: none;\n}\n.mobile-container{\n  display: block;\n  position: relative;\n}\n.close-btn{\n  background-color: white;\n}\n.wine-title-div{\n  display: block;\n  padding: 9% 0 7% 7%;\n}\n.wine-title{\n  margin-right: 2%;\n  font-size: 7.5vw;\n  line-height: 9vw;;\n  font-weight: 700;\n  font-style: normal;\n  letter-spacing: .05vw;\n  color: rgb(0, 0, 0);\n  margin: 0 0 .75% 0;\n}\n.year{\n  letter-spacing: .05vw;\n  font-size: 5.75vw;\n  line-height: 7vw;\n  color: rgb(0, 0, 0);\n  letter-spacing: .05vw;\n  margin: 0;\n  font-weight: 400;\n}\n.content-div{\n  display: flex;\n  position: relative; \n  z-index: 2;\n  width: 100vw;\n}\n.big-wine-container{\n  position: absolute;\n  z-index: 3;\n  height: 140vw;\n  width: 21vw;\n  padding: 0 5vw 0 6vw;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n  padding-top: 5%;;\n}\n.wine-image{\n  height: 75%;\n  z-index: 3;\n  background-color: transparent;\n  margin-bottom: 15%;\n  margin-left: 2%;\n}\n.wine-logo{\n  width: 100%;\n  height: auto;\n  margin: 0;\n  margin-left: 0%;\n}\n.right-col{\n  width: 100%;\n  height: auto;\n}\n.top-right{\n  display: flex;\n  flex-direction: column;\n  justify-content: start;\n  position: relative;\n  padding-right: 5%;\n  padding-left: 36.5%;\n  padding-bottom: 11%;\n}\n.bottom-right{\n  height: auto;\n  padding-top: 3%;\n  padding-right: 5%;\n  padding-left: 36.5%;\n  padding-bottom: 5%;\n}\n.my-profile-header{\n  margin: 0;\n  font-size: 4.5vw;\n  line-height: 5.5vw;\n  padding-top: 7%;\n  padding-bottom: 3%;\n  color: black;\n  font-weight: 700;\n  font-style: normal;\n  letter-spacing: .05vw;\n}\n.user-profile{\n  margin: 0;\n  font-size: 3.65vw;\n  line-height: 5.15vw;\n  color: rgb(0, 0, 0);\n  font-weight: 400;\n  font-style: normal;\n  letter-spacing: .05vw;\n}\n.flavors-header{\n  margin: 0;\n  padding-top: 12%;\n  padding-bottom: 5.75%;\n  font-size: 4vw;\n  color: black;\n  font-weight: 700;\n  font-style: normal;\n  letter-spacing: .05vw;\n}\n.flavors-container{\n  height: auto;\n  display: flex;\n}\n.flavor-box{\n  height: 100%;\n  margin-right: 10%;\n  width: 24%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: end; \n}\n.flav-img-container{\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 13vw;\n  width: 13vw;\n  border-radius: 10vw;\n  margin-bottom: 14%;\n}\n.user-flavor-img{\n  width: 85%;\n}\n.flavor-title{\n  font-size: 3vw;\n  line-height: 4vw;\n  font-weight: 400;\n  font-style: normal;\n  letter-spacing: .05vw;\n  text-align: center;\n  margin: 0;\n}\n.bottom{\n  margin-top: 6%;\n}\n.acid-sweetness-columns{\n  display: flex;\n  margin-top: 12%;\n}\n.acidity-col{\n  display: block;\n  width: 45%;\n  margin-right: 10%;\n}\n.acidity-header{\n  margin: 0;\n  padding-bottom: 3%;\n  font-size: 3.5vw;\n  margin-bottom: 4%;\n  color: black;\n  font-weight: 600;\n  font-style: normal;\n  letter-spacing: .05vw;\n}\n.acidity-bar{\n  display: flex;\n  align-items: center;\n  height: 2.75vw;\n  width: 100%;\n  border: 1px rgb(150, 150, 150) solid;\n  border-radius: 10vw;\n}\n.sweetness-col{\n  display: block;\n  width: 45%;\n}\n.sweetness-bar{\n  display: flex;\n  align-items: center;\n  height: 2.75vw;\n  width: 100%;\n  border: 1px rgb(150, 150, 150) solid;\n  border-radius: 10vw;\n}\n.acid-label-columns{\n  display: flex; \n  width: 100%;\n}\n.l-acid-col{\n  width: 50%;\n}\n.r-acid-col{\n  width: 50%;\n  display: flex;\n  justify-content: end;\n}\n.low-lable{\n  font-size: 2.35vw;\n  margin-bottom: 3%;\n  color: black;\n  font-weight: 400;\n  margin: 0;\n  padding-top: 13%;\n  margin-left: 2%;\n  letter-spacing: .01vw;\n}\n.high-lable{\n  font-size: 2.35vw;\n  color: black;\n  font-weight: 400;\n  margin: 0;\n  padding-top: 13%;\n  padding-right: 0%;\n  letter-spacing: .01vw;\n}\n.qr-code-section{\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10% 0 6.5% 0%;\n  width: 100%;\n}\n.share-link{\n  margin-bottom: 5%;\n  min-height: 27vw;\n  margin-right: 3%;\n  margin-left: 3%;\n  width: 22%;\n  text-decoration: none;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  background-color: transparent;\n  border: none;\n}\n.share-img{\n  width: 75%;\n  margin-bottom: 13%;\n}\n.share-lable{\n  text-decoration: none;\n  color: black;\n  font-size: 3.25vw;\n  line-height: 4.25vw;\n  font-weight: 400;\n  margin: 0;\n}\n.fade-in {\n  opacity: 1;\n  transition: opacity .5s linear;\n}\n.invisible {\n  opacity: .9;\n}\n/* Optional: You may want to add this to your loading-screen class */\n.loading-screen {\n  opacity: 1;\n  transition: opacity 0.5s ease-out;\n}\n.loading-screen {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  width: 100%;\n  background-color: #fdf9f1;\n}\n.loading-screen {\n  margin-top: 0px;\n  color: #860000;\n}\n.load-message{\n  color: black;\n  font-family: \"Helvetica-reg\";\n  font-weight: 600;\n  letter-spacing: .25vw;\n  font-size: 5.75vw;\n}\n.loading-spinner {\n  width: 20vw;\n  height: auto;\n  border-radius: 0%;\n  animation: spin 4s linear infinite;\n  margin-bottom: 20%;\n}\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n.sparkling-qr-mobile{\n  background-color: #fdf9f1;\n}\n\n\n\n@media only screen and (min-width: 700px) and (min-height: 1000px){\n\n  .App{\n    margin: 0;\n  }\n  .top-div{\n    position: relative;\n    margin: 0;\n  }\n  .desktop-container{\n    display: none;\n  }\n  .mobile-container{\n    display: block;\n    position: relative;\n  }\n  .wine-title-div{\n    display: block;\n    padding: 7% 0 1% 5%;\n  }\n  .wine-title{\n    margin-right: 2%;\n    font-size: 4vw;\n    font-weight: 700;\n    font-style: normal;\n    letter-spacing: .015vw;\n    color: rgb(0, 0, 0);\n    margin: 0;\n    line-height: 4.5vw;\n  }\n  .year{\n    font-weight: 400;\n    font-style: normal;\n    letter-spacing: .015vw;\n    font-size: 3.25vw;\n    line-height: 5vw;\n    color: rgb(0, 0, 0);\n    margin: 0;\n  }\n  .content-div{\n    display: flex;\n    position: relative; \n    z-index: 2;\n    width: 100vw;\n  }\n  .big-wine-container{\n    position: absolute;\n    z-index: 3;\n    height: 115vw;\n    width: 20vw;\n    padding: 0 5vw 0 5vw;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    padding-top: 0%;;\n  }\n  .wine-image{\n    height: 75%;\n    z-index: 3;\n    background-color: transparent;\n    margin-bottom: 12%;\n    margin-left: 2%;\n  }\n  .wine-logo{\n    width: 100%;\n    height: auto;\n    margin: 0;\n  }\n  .right-col{\n    width: 100%;\n    height: auto;\n  }\n  .top-right{\n    display: flex;\n    flex-direction: column;\n    justify-content: start;\n    position: relative;\n    padding-right: 5%;\n    padding-left: 35%;\n    padding-bottom: 8%;\n  }\n  .bottom-right{\n    height: auto;\n    padding-top: 2%;\n    padding-right: 5%;\n    padding-left: 35%;\n    padding-bottom: 5%;\n  }\n  .my-profile-header{\n    margin: 0;\n    line-height: 2.5vw;\n    font-size: 2.5vw;\n    padding-top: 7%;\n    padding-bottom: 2%;\n    color: black;\n    font-weight: 700;\n    font-style: normal;\n    letter-spacing: .015vw;\n  }\n  .user-profile{\n    margin: 0;\n    font-size: 2vw;\n    line-height: 3vw;\n    color: black;\n    font-weight: 400;\n    font-style: normal;\n    letter-spacing: .02vw;\n  }\n  .flavors-header{\n    margin: 0;\n    padding-top: 8%;\n    padding-bottom: 3.5%;\n    font-size: 2.5vw;\n    color: black;\n    font-weight: 600;\n    font-style: normal;\n    letter-spacing: .015vw;\n  }\n  .flavors-container{\n    height: auto;\n    display: flex;\n  }\n  .flavor-box{\n    height: 100%;\n    margin-right: 6%;\n    width: 20%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: end; \n  }\n  .flav-img-container{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 7vw;\n    width: 7vw;\n    border-radius: 10vw;\n    margin-bottom: 10%;\n  }\n  .user-flavor-img{\n    width: 70%;\n  }\n  .flavor-title{\n    font-size: 1.75vw;\n    line-height: 2.5vw;\n    font-weight: 400;\n    font-style: normal;\n    letter-spacing: .015vw;\n    text-align: center;\n    margin: 0;\n  }\n  .bottom{\n    margin-top: 6%;\n  }\n  .acid-sweetness-columns{\n    display: flex;\n    margin-top: 10%;\n  }\n  .acidity-col{\n    display: block;\n    width: 45%;\n    margin-right: 10%;\n  }\n  .acidity-header{\n    margin: 0;\n    padding-bottom: 3%;\n    font-size: 2.15vw;\n    margin-bottom: 3%;\n    color: black;\n    font-weight: 600;\n    font-style: normal;\n    letter-spacing: .015vw;\n  }\n  .acidity-bar{\n    display: flex;\n    align-items: center;\n    height: 1.8vw;\n    width: 100%;\n    border: 1px rgb(150, 150, 150) solid;\n    border-radius: 5vw;\n  }\n  .sweetness-col{\n    display: block;\n    width: 45%;\n  }\n  .sweetness-bar{\n    display: flex;\n    align-items: center;\n    height: 1.8vw;\n    width: 100%;\n    border: 1px rgb(150, 150, 150) solid;\n    border-radius: 5vw;\n  }\n  .acid-label-columns{\n    display: flex; \n    width: 100%;\n  }\n  .l-acid-col{\n    width: 50%;\n  }\n  .r-acid-col{\n    width: 50%;\n    display: flex;\n    justify-content: end;\n  }\n  .low-lable{\n    font-size: 1.5vw;\n    margin-bottom: 3%;\n    color: black;\n    font-weight: 400;\n    margin: 0;\n    padding-top: 12%;\n    margin-left: 2%;\n  }\n  .high-lable{\n    font-size: 1.5vw;\n    color: black;\n    font-weight: 400;\n    margin: 0;\n    padding-top: 12%;\n    padding-right: 2%;\n  }\n  .qr-code-section{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 5% 0 4% 0%;\n    width: 100%;\n  }\n  .share-link{\n    margin-bottom: 5%;\n    min-height: 20vw;\n    margin-right: 4%;\n    margin-left: 4%;\n    width: 20%;\n    text-decoration: none;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: flex-start;\n    background-color: transparent;\n    border: none;\n  }\n  .share-img{\n    width: 49%;\n    margin-bottom: 11%;\n  }\n  .share-lable{\n    text-decoration: none;\n    color: black;\n    font-size: 2.25vw;\n    line-height: 3.5vw;\n    font-weight: 400;\n    margin: 0;\n  }\n  .loading-screen {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    width: 100%;\n    background-color: #fdf9f1;\n  }\n  .loading-screen {\n    margin-top: 0px;\n    color: #860000;\n  }\n  .load-message{\n    color: black;\n    font-family: \"helvetica-neue-lt-pro\", sans-serif;\n    font-weight: 500;\n    letter-spacing: .5px;\n    font-size: 32px;\n  }\n  .loading-spinner {\n    width: 95px;\n    height: 95px;\n    border-radius: 0%;\n    animation: spin 4s linear infinite;\n    margin-bottom: 10px;\n  }\n  @keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }\n  .fade-in {\n    opacity: 1;\n    transition: opacity .8s ease-in;\n  }\n  \n  .invisible {\n    opacity: .1;\n  }\n  .loading-screen {\n    opacity: 1;\n    transition: opacity 0.5s ease-out;\n  }\n}\n\n\n@media screen and (min-width: 1000px){\n  .mobile-container{\n    display: none;\n  }\n  .desktop-container{\n    display: block;\n    position: relative;\n  }\n  .large-wine-container{\n    display: flex;\n    position: absolute;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 25%;\n    top: 0;\n    left: 0; \n    background-color: transparent !important;\n    z-index: 3;\n    height: 92vh;\n  }\n  .large-sparkling-container{\n    background-color: transparent !important;\n    top: 20px\n  }\n  .header{\n    display: flex;\n    position: relative;\n    height: 11vh;\n    padding-left: 25%;\n    padding-right: 5%;\n    border-bottom: 3px white solid;\n  }\n  .content{\n    background-color: #fdf9f1;\n    display: flex;\n    flex-direction: column;\n    align-items: start;\n    justify-content: center;\n    min-height: 75.5vh;\n    padding-left: 25%;\n    padding-right: 4%;\n  }\n  .sparkling-content{\n    min-height: 78vh;\n  }\n  .wine-img{\n    height: 82%;\n  }\n  .qr-code-section{\n    background-color: transparent;\n    display: flex;\n    align-items: center;\n    justify-content: start;\n    padding: 0% 0 0% 0%;\n    width: 100%;\n  }\n  .share-link{\n    margin-bottom: 0%;\n    min-height: 100%;\n    margin-right: 14px;\n    margin-left: 0px;\n    width: 130px;\n    text-decoration: none;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: start;\n    background-color: transparent;\n    border: none;\n    padding: 0;\n    cursor: pointer;\n  }\n  .share-img{\n    width: 32%;\n    margin-bottom: 0%;\n    margin-right: 8px;\n  }\n  .share-lable{\n    text-decoration: none;\n    color: black;\n    font-size: 13px;\n    line-height: 15px;\n    font-weight: 400;\n    letter-spacing: .25px;\n    margin: 0;\n    text-align: left;\n  }\n  .logo-desk-container{\n    height: 100%;\n    display: flex;\n    align-items: center;\n  }\n  .wine-logo{\n    width: auto;\n    height: 68%;\n    margin: 0;\n    padding: 0;\n  }\n  .name-div{\n    display: flex;\n    justify-content: end;\n    align-items: end;\n    margin-bottom: 35px;\n  }\n  .wine-title{\n    font-size: 32px;\n    font-weight: 700;\n    font-style: normal;\n    letter-spacing: 1px;\n    color: rgb(26, 26, 26);\n    margin: 0 22px 0 0;\n    line-height: 25px;\n    letter-spacing: .25px;\n  }\n  .wine-year{\n    font-size: 24px;\n    font-weight: 400;\n    color: rgb(26, 26, 26);\n    letter-spacing: .25px;\n  }\n  .flavor-columns{\n    display: flex;\n    width: 100%;\n  }\n  .l-col{\n    width: 46%;\n    margin-right: 4%;\n  }\n  .r-col{\n    width: 46%;\n    margin-left: 4%;\n  }\n  .profile-container{\n    min-height: 135px;\n  }\n  .my-profile-header{\n    margin: 0;\n    line-height: 18px;\n    font-size: 18px;\n    padding-top: 0;\n    padding-bottom: 10px;\n    color: black;\n    font-weight: 700;\n    font-style: normal;\n    letter-spacing: .25px;\n  }\n  .user-profile{\n    margin: 0;\n    font-size: 14px;\n    line-height: 20px;\n    color: black;\n    font-weight: 400;\n    font-style: normal;\n    letter-spacing: .25px;\n  }\n  .flavors-header{\n    margin: 0;\n    padding-top: 15px;\n    padding-bottom: 12px;\n    font-size: 16px;\n    color: black;\n    font-weight: 700;\n    font-style: normal;\n    letter-spacing: .25px;\n  }\n  .flavors-container{\n    min-height: 98px;\n  }\n  .flavor-box{\n    height: 100%;\n    margin-right: 22px;\n    width: 50px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: end; \n  }\n  .flav-img-container{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 45px;\n    width: 45px;\n    border-radius: 30px;\n    margin-bottom: 10px;\n  }\n  .user-flavor-img{\n    width: 70%;\n  }\n  .flavor-title{\n    font-size: 11px;\n    line-height: 14px;\n    font-weight: 400;\n    font-style: normal;\n    letter-spacing: .25px;\n    text-align: center;\n    margin: 0;\n  }\n  .acid-sweetness-columns{\n    display: flex;\n    margin-top: 10px;\n  }\n  .acidity-col{\n    display: block;\n    width: 45%;\n    margin-right: 10%;\n  }\n  .acidity-header{\n    margin: 0;\n    padding-bottom: 7px;\n    font-size: 13px;\n    margin-bottom: 2px;\n    color: black;\n    font-weight: 700;\n    font-style: normal;\n    letter-spacing: .25px;\n  }\n  .acidity-bar{\n    display: flex;\n    align-items: center;\n    height: 12px;\n    width: 100%;\n    border: 1px rgb(150, 150, 150) solid;\n    border-radius: 5vw;\n  }\n  .sweetness-col{\n    display: block;\n    width: 45%;\n  }\n  .sweetness-bar{\n    display: flex;\n    align-items: center;\n    height: 12px;\n    width: 100%;\n    border: 1px rgb(150, 150, 150) solid;\n    border-radius: 30px;\n  }\n  .acid-label-columns{\n    display: flex; \n    width: 100%;\n  }\n  .l-acid-col{\n    width: 50%;\n  }\n  .r-acid-col{\n    width: 50%;\n    display: flex;\n    justify-content: end;\n  }\n  .low-lable{\n    font-size: 11px;\n    margin-bottom: 3%;\n    color: black;\n    font-weight: 400;\n    margin: 0;\n    padding-top: 7px;\n    margin-left: 2%\n  }\n  .high-lable{\n    font-size: 11px;\n    color: black;\n    font-weight: 400;\n    margin: 0;\n    padding-top: 10px;\n    padding-right: 2%;\n  }\n\n  .loading-screen {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    width: 100%;\n    background-color: #fdf9f1;\n  }\n  .loading-screen {\n    margin-top: 0px;\n    color: #860000;\n  }\n  .load-message{\n    color: black;\n    font-family: \"helvetica-neue-lt-pro\", sans-serif;\n    font-weight: 500;\n    letter-spacing: .25px;\n    font-size: 24px;\n  }\n  .loading-spinner {\n    width: 70px;\n    height: auto;\n    border-radius: 0%;\n    animation: spin 3s linear infinite;\n    margin-bottom: 5px;\n  }\n  \n  @keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }\n\n  .fade-in {\n    opacity: 1;\n    transition: opacity .7s ease-in;\n  }\n  \n  .invisible {\n    opacity: .8;\n  }\n  .loading-screen {\n    opacity: 1;\n    transition: opacity .2s ease-in;\n  }\n  .effervescence-column{\n    margin-top: 20px;\n  }\n}\n\n@media screen and (min-width: 1400px) {\n  \n  .mobile-container{\n    display: none;\n  }\n  .desktop-container{\n    display: block;\n    position: relative;\n  }\n  .large-wine-container{\n    display: flex;\n    position: absolute;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 28%;\n    top: 0;\n    left: 0; \n    background-color: transparent;\n    z-index: 3;\n    height: 89vh;\n  }\n  .large-sparkling-container{\n    background-color: transparent !important;\n    top: 20px\n  }\n  .header{\n    display: flex;\n    position: relative;\n    height: 10.5vh;\n    padding-left: 28%;\n    padding-right: 4%;\n    border-bottom: 3px white solid;\n  }\n  .content{\n    background-color: #fdf9f1;\n    display: flex;\n    flex-direction: column;\n    align-items: start;\n    justify-content: center;\n    min-height: 77vh;\n    padding-left: 28%;\n    padding-right: 5%;\n  }\n  .sparkling-content{\n    min-height: 81vh;\n  }\n  .wine-img{\n    height: 90%;\n  }\n  .qr-code-section{\n    background-color: transparent;\n    display: flex;\n    align-items: center;\n    justify-content: start;\n    padding: 0% 0 0% 0%;\n    width: 100%;\n  }\n  .share-link{\n    margin-bottom: 0%;\n    min-height: 100%;\n    margin-right: 20px;\n    margin-left: 0px;\n    width: 150px;\n    text-decoration: none;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: start;\n    background-color: transparent;\n    border: none;\n    padding: 0;\n  }\n  .share-img{\n    width: 28%;\n    margin-bottom: 0%;\n    margin-right: 10px;\n  }\n  .share-lable{\n    text-decoration: none;\n    color: black;\n    font-size: 13px;\n    font-weight: 400;\n    margin: 0;\n    text-align: left;\n    line-height: 16px;\n  }\n  .logo-desk-container{\n    height: 100%;\n    display: flex;\n    align-items: center;\n  }\n  .wine-logo{\n    width: auto;\n    height: 65%;\n    margin: 0;\n    padding: 0;\n  }\n  .name-div{\n    display: flex;\n    justify-content: end;\n    align-items: end;\n    margin-bottom: 36px;\n  }\n  .wine-title{\n    font-size: 38px;\n    font-weight: 700;\n    font-style: normal;\n    letter-spacing: .25px;\n    color: rgb(26, 26, 26);\n    margin: 0 22px 0 0;\n    line-height: 40px;\n  }\n  .wine-year{\n    font-size: 30px;\n    font-weight: 400;\n    color: rgb(26, 26, 26);\n    letter-spacing: .25px;\n  }\n  .flavor-columns{\n    display: flex;\n    width: 100%;\n  }\n  .l-col{\n    width: 45%;\n    margin-right: 5%;\n  }\n  .r-col{\n    width: 45%;\n    margin-left: 5%;\n  }\n  .profile-container{\n    min-height: 142px;\n  }\n  .my-profile-header{\n    margin: 0;\n    line-height: 24px;\n    font-size: 20px;\n    padding-top: 0;\n    padding-bottom: 10px;\n    color: black;\n    font-weight: 700;\n    font-style: normal;\n    letter-spacing: .25px;\n  }\n  .user-profile{\n    margin: 0;\n    font-size: 15px;\n    line-height: 22px;\n    color: black;\n    font-weight: 400;\n    font-style: normal;\n    letter-spacing: .25px;\n  }\n  .flavors-header{\n    margin: 0;\n    padding-top: 22px;\n    padding-bottom: 14px;\n    font-size: 16px;\n    color: black;\n    font-weight: 700;\n    font-style: normal;\n    letter-spacing:.25px;\n  }\n  .flavors-container{\n    min-height: 100px;\n  }\n  .flavor-box{\n    height: 100%;\n    margin-right: 13px;\n    width: 75px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: end; \n  }\n  .flav-img-container{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 54px;\n    width: 54px;\n    border-radius: 30px;\n    margin-bottom: 10px;\n  }\n  .user-flavor-img{\n    width: 80%;\n  }\n  .flavor-title{\n    font-size: 12px;\n    line-height: 14px;\n    font-weight: 400;\n    font-style: normal;\n    letter-spacing: .5px;\n    text-align: center;\n    margin: 0;\n  }\n  .acid-sweetness-columns{\n    display: flex;\n    margin-top: 16px;\n    width: 96%;\n  }\n  .acidity-col{\n    display: block;\n    width: 45%;\n    margin-right: 10%;\n  }\n  .acidity-header{\n    margin: 0;\n    padding-bottom: 5px;\n    font-size: 15px;\n    margin-bottom: 5px;\n    color: black;\n    font-weight: 700;\n    font-style: normal;\n    letter-spacing: .25px;\n  }\n  .acidity-bar{\n    display: flex;\n    align-items: center;\n    height: 13px;\n    width: 100%;\n    border: 1px rgb(150, 150, 150) solid;\n    border-radius: 5vw;\n  }\n  .sweetness-col{\n    display: block;\n    width: 45%;\n  }\n  .sweetness-bar{\n    display: flex;\n    align-items: center;\n    height: 13px;\n    width: 100%;\n    border: 1px rgb(150, 150, 150) solid;\n    border-radius: 30px;\n  }\n  .acid-label-columns{\n    display: flex; \n    width: 100%;\n  }\n  .l-acid-col{\n    width: 45%;\n  }\n  .r-acid-col{\n    width: 45%;\n    display: flex;\n    justify-content: end;\n  }\n  .low-lable{\n    font-size: 11px;\n    margin-bottom: 3%;\n    color: black;\n    font-weight: 400;\n    margin: 0;\n    padding-top: 8px;\n    margin-left: 2%;\n  }\n  .high-lable{\n    font-size: 11px;\n    color: black;\n    font-weight: 400;\n    margin: 0;\n    padding-top: 8px;\n    padding-right: 0px;\n    margin-right: -17px;\n  }\n  .loading-screen {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    width: 100%;\n    background-color: #fdf9f1;\n  }\n  .loading-screen {\n    margin-top: 0px;\n    color: #860000;\n    font-family: your-font-family, sans-serif;\n  }\n  .load-message{\n    color: black;\n    font-family: \"helvetica-neue-lt-pro\", sans-serif;\n    font-weight: 500;\n    letter-spacing: .35px;\n    font-size: 26px;\n    margin: 0;\n    line-height: 34px;\n  }\n  .loading-spinner {\n    width: 85px;\n    height: 85px;\n    border-radius: 0%;\n    animation: spin 4s linear infinite;\n    margin-bottom: 18px;\n  }\n  \n  @keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }\n  .fade-in {\n    opacity: 1;\n    transition: opacity .6s ease-in;\n  }\n  .invisible {\n    opacity: .8;\n  }\n  /* Optional: You may want to add this to your loading-screen class */\n  .loading-screen {\n    opacity: 1;\n    transition: opacity 0.2s ease-in;\n  }\n  .effervescence-column{\n    margin-top: 25px;\n  }\n}\n\n@media screen and (min-width: 1900px){\n\n  .mobile-container{\n    display: none;\n  }\n  .desktop-container{\n    display: block;\n    position: relative;\n  }\n  .large-wine-container{\n    display: flex;\n    position: absolute;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    width: 31%;\n    top: 0;\n    left: 0; \n    background-color: transparent;\n    z-index: 3;\n    height: 87vh;\n  }\n  .large-sparkling-container{\n    background-color: transparent !important;\n    top: 0px\n  }\n  .header{\n    display: flex;\n    position: relative;\n    height: 10.5vh;\n    padding-left: 31%;\n    padding-right: 4%;\n  }\n  .content{\n    background-color: #fdf9f1;\n    display: flex;\n    flex-direction: column;\n    align-items: start;\n    justify-content: center;\n    min-height: 76.75vh;\n    padding-left: 31%;\n    padding-right: 6%;\n  }\n  .sparkling-content{\n    min-height: 80vh;\n  }\n  .wine-img{\n    height: 89%;\n  }\n  .qr-code-section{\n    background-color: transparent;\n    display: flex;\n    align-items: center;\n    justify-content: start;\n    padding: 0% 0 0% 0%;\n    width: 100%;\n  }\n  .share-link{\n    margin-bottom: 0%;\n    min-height: 100%;\n    margin-right: 22px;\n    margin-left: 0px;\n    width: 205px;\n    text-decoration: none;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: start;\n    background-color: transparent;\n    border: none;\n    padding: 0;\n  }\n  .share-img{\n    width: 24%;\n    margin-bottom: 0%;\n    margin-right: 13px;\n  }\n  .share-lable{\n    text-decoration: none;\n    color: black;\n    font-size: 15px;\n    line-height: 20px;\n    font-weight: 400;\n    margin: 0;\n    text-align: left;\n    letter-spacing: .5px;\n  }\n  .logo-desk-container{\n    height: 100%;\n    display: flex;\n    align-items: center;\n  }\n  .wine-logo{\n    width: auto;\n    height: 65%;\n    margin: 0;\n    padding: 0;\n  }\n  .name-div{\n    display: flex;\n    justify-content: end;\n    align-items: end;\n    margin-bottom: 42px;\n  }\n  .wine-title{\n    font-size: 46px;\n    font-weight: 700;\n    font-style: normal;\n    letter-spacing: .25px;\n    color: rgb(26, 26, 26);\n    margin: 0 22px 0 0;\n    line-height: 48px;\n  }\n  .wine-year{\n    font-size: 34px;\n    font-weight: 400;\n    color: rgb(26, 26, 26);\n    letter-spacing: .25px;\n  }\n  .flavor-columns{\n    display: flex;\n    width: 100%;\n  }\n  .l-col{\n    width: 43%;\n    margin-right: 6%;\n  }\n  .r-col{\n    width: 43%;\n    margin-left: 6%;\n  }\n  .profile-container{\n    min-height: 157px;\n  }\n  .my-profile-header{\n    margin: 0;\n    font-size: 24px;\n    line-height: 28px;\n    padding-top: 0;\n    padding-bottom: 13px;\n    color: black;\n    font-weight: 700;\n    font-style: normal;\n    letter-spacing: .25px;\n  }\n  .user-profile{\n    margin: 0;\n    font-size: 16px;\n    line-height: 24px;\n    color: black;\n    font-weight: 400;\n    font-style: normal;\n    letter-spacing: .25px;\n  }\n  .flavors-header{\n    margin: 0;\n    padding-top: 26px;\n    padding-bottom: 15px;\n    font-size: 19px;\n    color: black;\n    font-weight: 700;\n    font-style: normal;\n    letter-spacing: .25px;\n  }\n  .flavors-container{\n    min-height: 112px;\n  }\n  .flavor-box{\n    height: 100%;\n    margin-right: 17px;\n    width: 88px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: end; \n  }\n  .flav-img-container{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 61px;\n    width: 61px;\n    border-radius: 30px;\n    margin-bottom: 15px;\n  }\n  .user-flavor-img{\n    width: 77%;\n  }\n  .flavor-title{\n    font-size: 13px !important;\n    line-height: 18px !important;\n    font-weight: 400;\n    font-style: normal;\n    letter-spacing: .25px;\n    text-align: center;\n    margin: 0;\n  }\n  .acid-sweetness-columns{\n    display: flex;\n    margin-top: 36px;\n    width: 96%;\n  }\n  .acidity-col{\n    display: block;\n    width: 45%;\n    margin-right: 13%;\n  }\n  .acidity-header{\n    margin: 0;\n    padding-bottom: 5px;\n    font-size: 16px;\n    margin-bottom: 7px;\n    color: black;\n    font-weight: 700;\n    font-style: normal;\n    letter-spacing: .25px;\n  }\n  .acidity-bar{\n    display: flex;\n    align-items: center;\n    height: 15px;\n    width: 100%;\n    border: 1px rgb(150, 150, 150) solid;\n    border-radius: 5vw;\n  }\n  .sweetness-col{\n    display: block;\n    width: 45%;\n  }\n  .sweetness-bar{\n    display: flex;\n    align-items: center;\n    height: 15px!important;\n    width: 100%;\n    border: 1px rgb(150, 150, 150) solid;\n    border-radius: 30px;\n  }\n  .acid-label-columns{\n    display: flex; \n    width: 100%;\n  }\n  .l-acid-col{\n    width: 50%;\n  }\n  .r-acid-col{\n    width: 50%;\n    display: flex;\n    justify-content: end;\n  }\n  .low-lable{\n    font-size: 13px;\n    margin-bottom: 3%;\n    color: black;\n    font-weight: 400;\n    letter-spacing: .25px;\n    margin: 0;\n    padding-top: 8px;\n    margin-left: 2%;\n  }\n  .high-lable{\n    font-size: 13px;\n    color: black;\n    font-weight: 400;\n    margin: 0;\n    padding-top: 8px;\n    padding-right: 2px;\n    letter-spacing: .25px;\n    margin-right: 0;\n  }\n\n  .loading-screen {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    height: 100vh;\n    width: 100%;\n    background-color: #fdf9f1;\n  }\n  .loading-screen {\n    margin-top: 0px;\n    color: #860000;\n  }\n  .load-message{\n    color: black;\n    font-family: \"helvetica-neue-lt-pro\", sans-serif;\n    font-weight: 500;\n    letter-spacing: .5px;\n    font-size: 33px;\n  }\n  .loading-spinner {\n    width: 95px;\n    height: auto;\n    border-radius: 0%;\n    animation: spin 3s linear infinite;\n    margin-bottom: 8px;\n  }\n  \n  @keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }\n  .fade-in {\n    opacity: 1;\n    transition: opacity .6s ease-in;\n  }\n  .invisible {\n    opacity: 0.9;\n  }\n  /* Optional: You may want to add this to your loading-screen class */\n  .loading-screen {\n    opacity: 1;\n    transition: opacity 0.5s ease-out;\n  }\n  .effervescence-column{\n    margin-top: 40px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
